export default __webpack_public_path__ + "static/media/Oval-blue.fa6f39ee.svg";